import clsx from "clsx";
import { useParams, Link } from "react-router-dom";
import { useLocation } from "react-router";
import { checkIsActive } from "../../helpers";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export type Props = {
  to: string;
  onClick?: () => void;
  icon: React.ReactNode;
  title: string;
  collapsed?: boolean;
};

export const SideMenuItem: React.FC<Props> = ({
  to,
  onClick,
  icon,
  title,
  collapsed = false,
}) => {
  const { storeId } = useParams();
  const { pathname } = useLocation();
  const isActive = checkIsActive(pathname, to, storeId);

  return (
    <li>
      <OverlayTrigger
        placement={"right"}
        overlay={collapsed ? <Tooltip>{title}</Tooltip> : <></>}
      >
        <Link
          className={clsx({ active: isActive, "collapsed-item": collapsed })}
          to={to}
          onClick={onClick}
        >
          <span className="menu-icon">
            {icon}
            {/* <img src={icon} alt={title} /> */}
          </span>
          {!collapsed && <span className="menu-title">{title}</span>}
        </Link>
      </OverlayTrigger>
    </li>
  );
};
